import type { ReactNode } from 'react';
import { ClusterHeatmapSection } from '../components/ClusterHeatmapSection';

import { DashboardMetricGrid } from '../components/DashboardMetricGrid';
import { MonthlyClusterCostChartSection } from '../components/MonthlyClusterCostChartSection';
import { ResourcesUtilizationChartSection } from '../components/ResourcesUtilizationChartSection';
import { Stack } from '@cast/design-system';
import { DashboardBanners } from '@cast/split-me/features/dashboard/components/DashboardBanners';

type DashboardTabProps = {
  emptyStateActions?: ReactNode;
  clusterPathTemplate?: string;
};

export const DashboardTab = ({
  emptyStateActions,
  clusterPathTemplate,
}: DashboardTabProps) => (
  <Stack gap={20} data-testid="dashboard-page">
    <DashboardBanners />
    <DashboardMetricGrid />
    <ClusterHeatmapSection
      emptyStateActions={emptyStateActions}
      clusterPathTemplate={clusterPathTemplate}
    />
    <ResourcesUtilizationChartSection />
    <MonthlyClusterCostChartSection />
  </Stack>
);
